import React from 'react'
import { FormikProps } from 'formik'
import { useProfileShortURL } from '../../hooks/useProfileShortURL'

export interface WorkspaceProfileURLFieldRootProps<
  TName extends string,
  TFormValues extends Record<TName, string>,
> {
  shortUrl: string
  name: TName
  formikBag: FormikProps<TFormValues>
  children: (
    props: ReturnType<typeof useProfileShortURL>
  ) => React.ReactElement | null
}

export const WorkspaceProfileURLFieldRoot = <
  TName extends string,
  TFormValues extends Record<TName, string>,
>({
  shortUrl,
  children,
}: WorkspaceProfileURLFieldRootProps<
  TName,
  TFormValues
>): React.ReactElement | null => {
  const props = useProfileShortURL(shortUrl)

  return children(props)
}
